/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioTiposBodegasCV from './controladorVista/formularioTiposBodegasCV';
import TablaTiposBodegasCV from './controladorVista/tablaTiposBodegasCV';
import { estadoIncial, reductor } from './reductorTiposBodegas';

const TiposBodegas: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaTiposBodegasCV />
        <FormularioTiposBodegasCV />
    </ProveedorEstado>
);

export default TiposBodegas;
